// GTIN/EAN-Hilfen fuer SKU-Felder: Barcode-Scanner (Hardware wie Kamera) liefern die GTIN,
// gebraucht wird die SKU aus dem Artikelstamm (Products.Gtin seit 26.08.2026).

/** true, wenn der Wert wie eine GTIN aussieht (8-14 Ziffern, Leerzeichen/Bindestriche erlaubt). */
export function isGtin(value) {
  const digits = String(value || "").replace(/[\s-]/g, "");
  return /^\d{8,14}$/.test(digits);
}

/**
 * Sucht im Artikelstamm-Lookup (Eintraege mit `gtin`) den Artikel zur GTIN.
 * Genau ein Treffer (ohne _bware) -> Artikel, sonst null (unbekannt oder mehrdeutig).
 * 12-stellige UPC-Codes werden auch mit fuehrender 0 verglichen.
 */
export function findByGtin(products, value) {
  if (!isGtin(value)) return null;
  const digits = String(value).replace(/[\s-]/g, "");
  const candidates = digits.length === 12 ? [digits, "0" + digits] : [digits];
  const hits = (products || []).filter((p) => p.gtin && candidates.includes(String(p.gtin)) && !/_bware$/i.test(p.sku || ""));
  return hits.length === 1 ? hits[0] : null;
}
